import {
  EnhancedDataBackendError,
  FieldError,
  LineItem,
  LineItemFieldErrorMap,
  LineItemStateData,
} from '../../Type/EnhancedData'
import { FieldMap } from '../../types'
import { ED_FIELD_SPEC } from './Constants'

const LINE_ITEM_FIELD_REGEX = /^(enhanced_data|input)\/line_items\/(\d+)\/(.+)$/

const RAW_ED_FIELD_TO_DISPLAY_NAME_MAP: Record<string, string> = {
  customer_reference_id: ED_FIELD_SPEC.level2.customerReferenceId.displayName,
  customer_tax_id: ED_FIELD_SPEC.level2.customerTaxId.displayName,
  merchant_tax_id: ED_FIELD_SPEC.level2.merchantTaxId.displayName,
  invoice_number: ED_FIELD_SPEC.level2.invoice.displayName,
  'billing_address/postal_code': ED_FIELD_SPEC.level2.sourceZipCode.displayName,
  'source_address/postal_code': ED_FIELD_SPEC.level2.sourceZipCode.displayName,
  'shipping_address/postal_code': ED_FIELD_SPEC.level2.shippingZipCode.displayName,
  'destination_address/postal_code': ED_FIELD_SPEC.level2.shippingZipCode.displayName,
  'shipping_address/country': ED_FIELD_SPEC.level2.shippingCountry.displayName,
  'destination_address/country': ED_FIELD_SPEC.level2.shippingCountry.displayName,
  local_tax_amount: ED_FIELD_SPEC.level3.taxAmount.displayName,
  freight_amount: ED_FIELD_SPEC.level3.freightAmount.displayName,
  discount_amount: ED_FIELD_SPEC.level3.discountAmount.displayName,
}

export const addLineItemError = (
  lineItemErrors: Record<string, LineItemFieldErrorMap>,
  match: RegExpMatchArray,
  messages: string[] | string,
  lineItemFieldMap: FieldMap<LineItem, LineItemStateData>
): void => {
  const rawFieldName: string = match[match.length - 1]
  const index = match[match.length - 2]
  const fieldName = (lineItemFieldMap[rawFieldName] ?? rawFieldName)
  // TODO: index needs to be mapped with the Unique LineItem Row ID or
  // LineItem rows needs to be mapped by 0-based index
  lineItemErrors[index] ??= {}
  lineItemErrors[index][fieldName] = {
    isVisible: true,
    message: (Array.isArray(messages) ? messages[0] : messages) ?? '',
    displayName: ED_FIELD_SPEC.line_item?.[fieldName]?.displayName ?? String(fieldName),
  }
}

const addEnhancedDataFieldError = (
  fieldErrorMap: Record<string, FieldError>,
  fieldPath: string,
  messages: string[] | string
): void => {
  const strippedPath = fieldPath.replace(/^enhanced_data\//, '')
  fieldErrorMap[fieldPath] = {
    isVisible: true,
    message: Array.isArray(messages) ? messages[0] : messages,
    displayName: (RAW_ED_FIELD_TO_DISPLAY_NAME_MAP)[strippedPath] ?? strippedPath,
  }
}

export const getParsedBackendValidationError = (
  errors: Record<string, string[] | string> = {},
  lineItemFieldMap: FieldMap<LineItem, LineItemStateData>
): EnhancedDataBackendError => {
  const lineItemErrors: Record<string, LineItemFieldErrorMap> = {}
  const otherErrors: string[] = []
  const fieldErrorMap: Record<string, FieldError> = {}
  for (const [fieldPath, messages] of Object.entries(errors)) {
    const lineItemFieldPath = fieldPath.match(LINE_ITEM_FIELD_REGEX)
    if (lineItemFieldPath) {
      addLineItemError(lineItemErrors, lineItemFieldPath, messages, lineItemFieldMap)
    } else if (fieldPath.startsWith('enhanced_data/line_items') || fieldPath.startsWith('input/line_items')) {
      otherErrors.push(Array.isArray(messages) ? messages[0] : messages)
    } else if (fieldPath.startsWith('enhanced_data')) {
      addEnhancedDataFieldError(fieldErrorMap, fieldPath, messages)
    } else {
      const errorMessage = `${fieldPath}: ${Array.isArray(messages) ? messages[0] : messages}`
      otherErrors.push(errorMessage)
    }
  }

  return { lineItemErrors, fieldErrorMap, otherErrors }
}
